export enum SensorConnectivityErrors {
  // O365
  AUTHENTICATION_ERROR = 1,
  PERMISSION_ERROR = 2,
  // AWS
  NON_EXISTENT_QUEUE = 801,
  INVALID_CLIENT_TOKEN_ID = 802,
  SIGNATURE_DOES_NOT_MATCH = 803,
  // AD
  REQUIRED_GROUP_POLICY = 901,
  BEST_NOT_INSTALLED = 902,
  NO_CONNECTION_TO_BEST = 903,
  RESTART_REQUIRED = 904,
  REQUIRED_CA_POLICY = 912,
  // NSVA
  LURKER_CONNECTION_ERROR = 905,
  GHOSTR_NO_PROBE = 906,
  GHOSTR_CANNOT_OPEN_PCAP_INTERFACE = 907,
  GHOSTR_NO_TRAFFIC = 908,
  SUBNET_CONFIG_NEEDED = 909,
  GATEWAY_CONFIG_NEEDED = 910,
  SUBNET_GATEWAY_CONFIG_NEEDED = 911,
  GHOSTR_NO_BRAIN = 913,
  GHOSTR_NO_PCAP_DEVICE_SET = 914,
  OS_UPGRADE_REQUIRED = 915,
  CRITICAL_PROTECTION_DISABLED = 916,

  UNKNOWN_ERROR = 999,
  LICENSE_INACTIVE = 1000,
  DISABLED = 1001,
}

export enum SensorDeleteActionErrors {
  USER_DOES_NOT_EXIST_OR_DO_NOT_HAVE_PERMISSION = 3110,
  CANNOT_DELETE_LAST_SENSOR_IN_THE_INTEGRATION = 3352,
  CANNOT_DELETE_SENSOR_THAT_IS_NOT_OFFLINE_OR_UNMANAGED = 3353,
}

export enum O365MailFields {
  APPLICATION = 'o365_mail_applicationid',
  TENANT = 'o365_mail_tenantid',
  CLIENT_SECRET = 'o365_mail_client_secret',
}

export enum O365AuditFields {
  APPLICATION = 'o365_audit_applicationid',
  TENANT = 'o365_audit_tenantid',
  CLIENT_SECRET = 'o365_audit_client_secret',
}

export enum NSVAVirtualApplianceErrorReasons {
  SCAN_TARGETS_CONFIG_NEEDED = 'ScanTargetsConfigNeeded',
  SCAN_INTERFACES_CONFIG_NEEDED = 'ScanInterfacesConfigNeeded',
  SCAN_TARGETS_INTERFACES_CONFIG_NEEDED = 'ScanTargetsInterfacesConfigNeeded',
  GHOSTR_NO_BRAIN = 'GhostrNoBrain',
  GHOSTR_NO_PCAP_DEVICE_SET = 'GhostrNoPCAPDeviceSet',
  OS_UPGRADE_REQUIRED = 'OSUpgradeRequired',
  CRITICAL_PROTECTION_DISABLED = 'CriticalProtectionDisabled',
  ACTIVE = 'Active',
  DISABLED = 'Disabled',
  UNLICENSED = 'Unlicensed',
}
